import { render, staticRenderFns } from "./ElectricalDamageTypeSection.vue?vue&type=template&id=748eef7c&scoped=true"
import script from "./ElectricalDamageTypeSection.vue?vue&type=script&lang=ts"
export * from "./ElectricalDamageTypeSection.vue?vue&type=script&lang=ts"
import style0 from "./ElectricalDamageTypeSection.vue?vue&type=style&index=0&id=748eef7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748eef7c",
  null
  
)

export default component.exports